import axios from "axios";
import { base_url } from "../config";

// default
axios.defaults.baseURL = base_url.erp_auth;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// if token is present in sessionStorage, set it as default authorization header
// this will be used in all the requests
// if you want to set it for a specific request, use setAuthorization method
// const token = JSON.parse(sessionStorage.getItem("token")) ? sessionStorage.getItem("token") : null;
// if (token){
//   console.log('set default auth header auth', token);
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// }

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    // Para respuestas blob (file downloads), devolver la respuesta completa
    // para poder acceder a los headers
    // if (response.config.responseType === 'blob' || response.data instanceof Blob) {
    //   return response;
    // }
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);


class ApiAuthClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};


export { ApiAuthClient, setAuthorization };